import * as React from 'react';
import { useSelector } from 'react-redux';

import { Button } from '@lightspeed/flame/Button';
import { Flex } from '@lightspeed/flame/Core';
import { theme } from '@lightspeed/flame/Core/themes/flame';
import { Text } from '@lightspeed/flame/Text';

import { getStore } from 'pages/store/selectors/employeeShops';

interface Props {
  disabled: boolean;
  onClickEdit: () => void;
}

const EditShopsButton: React.FC<Props> = ({ disabled, onClickEdit }) => {
  const { isPrimaryUser, shops } = useSelector(getStore);
  const employeeShops = shops.filter((shop) => shop.hasAccess);

  return (
    <Flex justifyContent="space-between" alignItems="center" p={1}>
      {isPrimaryUser ? (
        <Text fontWeight="bold" textAlign="left" py={1}>
          You do not have permission to edit location access.
        </Text>
      ) : (
        <>
          <Text
            data-test="shop-counter"
            color={disabled ? theme.colors['gray-600'] : theme.colors.black}
          >
            <var>{employeeShops.length}</var> of <var>{shops.length}</var> locations
          </Text>
          <Button
            aria-label="button-edit-shop-access"
            data-test="edit-shops-btn"
            disabled={disabled}
            fill
            minWidth={48}
            onClick={onClickEdit}
            p={1}
          >
            Edit
          </Button>
        </>
      )}
    </Flex>
  );
};

export default EditShopsButton;
